import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ExpandablePanel from '../../../../../../common/widgets/ExpandablePanel';
import Icons from '../../../../../../common/widgets/Icons';
import PopoverDialog from '../../../../../../common/widgets/PopoverDialog';
import MyAccountMenu from '../../../../Pages/MyAccount/Common/MyAccountMenu';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { resources } from '../../../../resources/resources';
import UserMenu from '../UserMenu';

interface IAccountProps {
  isTablet: boolean;
  closeMenu?: () => void;
}

export default function Account(props: Readonly<IAccountProps>) {
  const { t: translate } = useTranslation();
  const { isTablet, closeMenu } = props;

  const { customerInfo } = useContext(CustomerInfoContext);

  return (
    <>
      {!isTablet ? (
        <PopoverDialog
          className="dropdown-menu-list account-menu-dropdown"
          placement="bottom"
          closeFromContent
          type="hover"
          content={<UserMenu />}
        >
          <Link
            to="/my-account/dashboard"
            className="btn app-bar-tools-btn app-bar-user"
          >
            <span className="btn-icon alerts-count">
              <Icons.User />
              {customerInfo.notificationsCount > 0 && (
                <span>{customerInfo.notificationsCount}</span>
              )}
            </span>
            <span className="btn-text">
              {translate(resources.menu.account)}
            </span>
            <span className="btn-icon">
              <Icons.ArrowDown />
            </span>
          </Link>
        </PopoverDialog>
      ) : (
        <ExpandablePanel
          arrowType="downMobile"
          title={
            <Link
              to="/my-account/dashboard"
              onClick={() => closeMenu?.()}
              className="btn app-bar-tools-btn app-bar-user app-bar-expand"
            >
              <span className="btn-icon alerts-count">
                <Icons.User />
                {customerInfo.notificationsCount > 0 && (
                  <span>{customerInfo.notificationsCount}</span>
                )}
              </span>
              <span className="btn-text">
                {translate(resources.menu.account)}
              </span>
            </Link>
          }
        >
          <MyAccountMenu menuClose={closeMenu} />
        </ExpandablePanel>
      )}
    </>
  );
}
